import Vue from "vue";
import App from "@/channelClient/App.vue";
import router from "@/channelClient/router";

import Element from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import locale from "element-ui/lib/locale/lang/en";
import './main.css';

Vue.use(Element, { locale });

Vue.config.productionTip = false;

new Vue({
	router,
	render: (h) => h(App),
}).$mount("#app");
